import { RouteObject } from 'react-router-dom'
import { ERoutes } from 'common/entities/routes'

const IdentityValidate: RouteObject[] = [
  {
    path: ERoutes.IDENTITY_VALIDATE,
    async lazy() {
      const { default: Component } = await import('pages/IdentityValidate')
      return { Component }
    },
  },
]

export default IdentityValidate
